

const ContentLanding = () => {
  return (
    <div className="container px-5 py-24 mx-auto mt-10 md:mt-20 text-gray-600">
      <div className="text-center font-semibold w-full font-sans">
        <div className="lg:w-2/3 mx-auto space-y-6 text-xl md:text-3xl">
          <p className="leading-10">
            Welcome to Lake Wickaboag Boat Club, your exclusive gateway
            to the tranquil waters of our small town gem.
          </p>

          <p className="leading-10">
            Nestled on the shores of Lake Wickaboag and located in quaint
            West Brookfield, Massachusetts, our private boat club offers a
            unique and intimate experience for boating, sailing, and kayak
            enthusiasts.
          </p>
          
          <p className="leading-10">
            Members enjoy a tight-knit community as well as the serenity
            and camaraderie that Lake Wickaboag Boat Club has to offer.
          </p>
          
        </div>
         
      </div>
    </div>
  );
};

export default ContentLanding